import React, { useState, useEffect } from "react";
import { Modal, Row, Button, Card, Avatar, Col } from "antd";
import { connect } from "react-redux";
import { getUserInfo, getUserList } from "redux/selectors";
import Table from "atoms/Table";
import styled from "styled-components";
import user from "./User_02.png";
import frame from "./Frame.png";
import { useParams } from "react-router-dom";
import { CALL_API } from "common/API";
import { STATUS_CODE } from "common/Constants";
const ModalWrap = styled.div`
  font-size: 18px;
  font-weight: 500;
`;
const StyledSpan = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: #636980;
`;
const Sectiontitle = styled.section`
  font-weight: 500;
  font-size: 16px;
  padding-bottom: 10px;
`;

function Viewmodal({ userList, userInfo }) {
  const { id } = useParams();
  const [details, setDetails] = useState({});
  const [isModalVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const getDetails = async () => {
    setLoading(true);
    const { appraisalList, code } = await CALL_API(
      `appraisal/${id}`,
      "get",
      {}
    );
    if (code === STATUS_CODE?.SUCCESS) {
      setDetails(appraisalList[0]);
      setLoading(false);
    }
  };

  useEffect(() => {
    getDetails();
  }, []);
  const findUser = userList?.find((item) => item?.userid === userInfo?.userid);
  const appraisalInformation = findUser?.appraisalInformation?.filter(
    (val) => val?.appraisal === "Yes"
  );
  // console.log("appraisal information-->", appraisalInformation);
  // console.log("finduser-->", findUser);

  const [selectedSegment, setSelectedSegment] = useState(
    appraisalInformation?.[0]?.roletype || null
  );
  const [appraisalIndex, setAppraisalIndex] = useState(1);
  const dataSource = [
    {
      key: "1",
      orgLevel: "Kenya",
      Area_of_Work: "Advisory",
      Sub_Area_of_Work: "Risk Advisory",
      Role_Level: "Leader",
      appraiser: "Cliford Ah Chip",
      Weightage: "45%",
      Role_Type: "Primary",
      appraisal: "Y",
    },
    {
      key: "2",
      Org_Level: "Sub-Cluster 1(Kenya,Somalia,Djibouti)",
      Area_of_Work: "Advisory",
      Sub_Area_of_Work: "-/-",
      Role_Level: "Leader",
      appraiser: "Cliford Ah Chip",
      Weightage: "10%",
      Role_Type: "Additional",
      appraisal: "Y",
    },
    {
      key: "3",
      Org_Level: "Cluster",
      Area_of_Work: "Advisory",
      Sub_Area_of_Work: "-/-",
      Role_Level: "Backstop",
      appraiser: "Cliford Ah Chip",
      Weightage: "15%",
      Role_Type: "Additional",
      appraisal: "Y",
    },
    {
      key: "4",
      Org_Level: "Cluster",
      Area_of_Work: "Advisory",
      Sub_Area_of_Work: "-/-",
      Role_Level: "Backstop",
      appraiser: "Cliford Ah Chip",
      Weightage: "15%",
      Role_Type: "Additional",
      appraisal: "Y",
    },
    {
      key: "5",
      Org_Level: "Cluster",
      Area_of_Work: "Advisory",
      Sub_Area_of_Work: "-/-",
      Role_Level: "Member",
      appraiser: "Sandeep",
      Weightage: "15%",
      Role_Type: "Additional",
      appraisal: "Y",
    },
    {
      key: "6",
      Org_Level: "Cluster",
      Area_of_Work: "Advisory",
      Sub_Area_of_Work: "-/-",
      Role_Level: "Member",
      appraiser: "Sandeep",
      Weightage: "0",
      Role_Type: "Additional",
      appraisal: "N",
    },
  ];
  const columns = [
    {
      title: "Org Level",
      dataIndex: "orgLevel",
      key: "orgLevel",
    },
    {
      title: "Area of Work",
      dataIndex: "areaofwork",
      key: "areaofwork",
    },
    {
      title: "Sub Area of Work",
      dataIndex: "subareaofwork",
      key: "subareaofwork",
    },
    {
      title: "Role Level",
      dataIndex: "rolelevel",
      key: "rolelevel",
    },
    {
      title: "Appraiser",
      dataIndex: "appraiser",
      key: "appraiser",
    },
    {
      title: "Weightage(%)",
      dataIndex: "weightage",
      key: "weightage",
    },
    {
      title: "Role Type",
      dataIndex: "roletype",
      key: "roletype",
    },
    {
      title: "Appraisal",
      dataIndex: "appraisal",
      key: "appraisal",
    },
  ];
  const handleSegmentChange = (value) => {
    const index = appraisalInformation.findIndex(
      (item) => item.roletype === value
    );

    setSelectedSegment(value);
    setAppraisalIndex(index + 1);
  };

  return (
    <ModalWrap>
      {appraisalInformation?.map((val) =>
        val?.roletype === selectedSegment && Object.keys(details).length ? (
          <>
            <img
              src={user}
              className="user-icon"
              onClick={showModal}
              style={{
                width: "45px",
                height: "45px",
                objectFit: "contain",
                backgroundColor: "#C2FAE5",
                backgroundSize: "90px",
                position: "fixed",
                bottom: "90px",
                right: "40px",
                padding: "5px",
                borderRadius: "50%",
              }}
            />
            <img
              src={frame}
              className="user-icon"
              onClick={showModal}
              style={{
                width: "10.13px",
                height: "13.19px",
                objectFit: "contain",
                backgroundColor: "#C2FAE5",
                backgroundSize: "50px",
                position: "fixed",
                bottom: "95px",
                right: "45px",
                borderRadius: "50%",
              }}
            />

            <Modal
              title="My Info"
              open={isModalOpen}
              onCancel={handleCancel}
              size="lg"
              width={1230}
              bodyStyle={{ height: 450, overflowY: "auto" }}
              visible={isModalVisible}
              footer={null}
            >
              <Card
                style={{
                  background: "#F3FEFA",
                  width: "1237",
                  height: "105",
                  border: "1px solid rgba(226, 226, 232, 1)",
                }}
                className="card-container"
              >
                <Row gutter={40}>
                  <Col xs={2}>
                    <div
                      style={{
                        width: "73px",
                        height: "73px",
                        borderRadius: "39.32px",
                      }}
                    >
                      {findUser?.profileurl || "-"}
                    </div>
                  </Col>
                  <Col xs={6}>
                    <div>
                      <p
                        style={{
                          fontSize: "18px",
                          fontWeight: "500",
                          margin: "0",
                        }}
                      >
                        {findUser?.fullname || "-"} ({findUser?.grade || "-"})
                      </p>
                      <StyledSpan
                        style={{
                          fontSize: "16px",
                          fontWeight: "500",
                          margin: "0",
                        }}
                      >
                        {findUser?.designation || "-"}
                      </StyledSpan>
                    </div>
                  </Col>
                  <Col xs={6}>
                    <div className="details1">
                      <p>
                        Employee ID:{" "}
                        <StyledSpan>{findUser?.employeeid || "-"}</StyledSpan>{" "}
                        <br />
                        Managing office:{" "}
                        <StyledSpan>
                          {findUser?.managingoffice || "-"}
                        </StyledSpan>{" "}
                        <br />
                        Location:{" "}
                        <StyledSpan>{findUser?.country || "-"}</StyledSpan>
                      </p>
                    </div>
                  </Col>
                  <Col xs={6} style={{ paddingLeft: "100px" }}>
                    <div className="details2">
                      <p>
                        Department:{" "}
                        <StyledSpan>{findUser?.jobtitle || "-"}</StyledSpan>{" "}
                        <br />
                        Hired Date:{" "}
                        <StyledSpan>
                          {findUser?.hireddate || "-"}
                        </StyledSpan>{" "}
                        <br />
                        Expertise:{" "}
                        <StyledSpan>{findUser?.expertise || "---"}</StyledSpan>
                      </p>
                    </div>
                  </Col>
                </Row>
              </Card>
              <br />
              <div>
                <Sectiontitle>Work Information</Sectiontitle>
              </div>
              <Row gutter={40}>
                <Col xs={5}>
                  <div>
                    <p style={{ lineHeight: "2.5", margin: "0" }}>
                      <StyledSpan>
                        Contracting Company (s)
                        <br />
                        Target Changeability
                        <br />
                        Last Promotion Level
                      </StyledSpan>
                    </p>
                  </div>
                </Col>
                <Col xs={6}>
                  <div>
                    <p style={{ lineHeight: "2.5", margin: "0" }}>
                      {findUser?.companyname || "---"} <br />
                      {findUser?.targetchargeability || "---"} <br />
                      {findUser?.lastpromotion || "---"}
                    </p>
                  </div>
                </Col>
                <Col xs={6} style={{ paddingLeft: "60px" }}>
                  <div>
                    <p style={{ lineHeight: "2.5", margin: "0" }}>
                      <StyledSpan>
                        Target Charge out rate
                        <br />
                        Last Promotion Date
                        <br />
                        No. of Dependents
                      </StyledSpan>
                    </p>
                  </div>
                </Col>
                <Col xs={6}>
                  <div>
                    <p style={{ lineHeight: "2.5", margin: "0" }}>
                      {findUser?.chargeoutrate || "---"} <br />
                      {findUser?.lastpromotionlevel || "---"} <br />
                      {findUser?.dependent || "---"}
                    </p>
                  </div>
                </Col>
              </Row>
              <br />
              <div>
                <Sectiontitle>Appraisal Information</Sectiontitle>
              </div>
              <Table
                dataSource={appraisalInformation}
                columns={columns}
                pagination={false}
              />
            </Modal>
          </>
        ) : null
      )}
    </ModalWrap>
  );
}

const mapStateToProps = (state) => ({
  userInfo: getUserInfo(state),
  userList: getUserList(state),
});
export default connect(mapStateToProps)(Viewmodal);
